import Page from "./index";
import CoinContract from "./CoinContract/index.vue";
import SpotContract from "./SpotContract/index.vue";
import FeeRateWhitelist from "./FeeRateWhitelist/index.vue";

export default {
  path: "/coin",
  component: Page,
  redirect: "/coin/spot",
  children: [
    { path: "/coin/spot", component: SpotContract },
    { path: "/coin/contract", component: CoinContract },
    { path: "/coin/fee-rate-whitelist", component: FeeRateWhitelist },
  ],
};
